"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormFieldErrorMessage = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormFieldErrorMessage = function (_a) {
    var _b = _a.messageId, messageId = _b === void 0 ? '' : _b;
    var messages = messageId.split('\n');
    return (react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid", style: { display: 'block' } }, messages.map(function (message, i) { return (react_1.default.createElement("div", { key: i }, message)); })));
};
exports.AcFormFieldErrorMessage = AcFormFieldErrorMessage;
exports.AcFormFieldErrorMessage.displayName = 'AcFormFieldErrorMessage';
//# sourceMappingURL=AcFormFieldErrorMessage.js.map